import React, {useState, useEffect, useMemo} from 'react';
import styles from './BindTemplates.module.css';

import { SelectMultiCheckboxSimple } from '../../SelectMultiCheckboxSimple/SelectMultiCheckboxSimple';
import cn from 'classnames';
import Button from '../../Button/Button';
import {getAllTemplateBindsUrl} from '../../../helpers/constants';
import useApi from '../../../hooks/useApi.hook';
import BindedItem from '../BindedItem/BindedItem';

export default function BindTemplates({
	valueProfId,
	options = [],
	setErrorApi,
	getBinds,
	bindsDict
}) {

	const api = useApi();
	const [selectedOptions, setSelectedOptions] = useState([]);
	const itemDict = useMemo(
		() => Object.fromEntries((options || []).map(({ value, label }) => [value, label])),
		[options]
	);

	const bindTemplates = async () => {
		const ids = selectedOptions.map(id => Number(id));
		if (ids.length === 0) {
			if (typeof getBinds === 'function') getBinds();
			return;
		}
		const payload = {
			file_template_ids: ids,
			profession_ids: [Number(valueProfId)]
		};
		try {
			await api.post(`${getAllTemplateBindsUrl}to_many`, payload);
			if (typeof getBinds === 'function') getBinds();
		} catch (e) {
			if (typeof setErrorApi === 'function') {
				setErrorApi(e.response?.data?.detail || e.response?.data?.message || 'Неизвестная ошибка');
			}
		}
	};

	useEffect(() => {
		if (!valueProfId || Number(valueProfId) === 0) {
			setSelectedOptions([]);
			return;
		}
		const selected = Object.values(bindsDict)
			.filter(bind => Number(bind.profession_id) === Number(valueProfId))
			.map(bind => String(bind.file_template_id));
		setSelectedOptions(selected);
	}, [valueProfId, bindsDict]);

	return (
		<div className={styles.filtersTable}>
			<div className={styles.selectBox}>
				<label
					className={`${styles.labelSelect} ${selectedOptions.length ? styles.labelActive : ''}`}
				>
					Шаблоны:
				</label>
				<SelectMultiCheckboxSimple
					options={options}
					value={selectedOptions}
					onChange={setSelectedOptions}
					placeholder="Фильтр по шаблону"
				/>
			</div>
			<div className={styles.bind_button_box}>
				<Button
					className={cn(styles.bind_button, {
						[styles.disabled]: !valueProfId || Number(valueProfId) === 0
					})}
					onClick={bindTemplates}>
						Привязать
				</Button>
			</div>
			<div className={styles.binds_box}>
				{Object.values(bindsDict)
					.filter(bind => String(bind.profession_id) === String(valueProfId))
					.map(bind => (
						<BindedItem
							key={bind.id}
							api={api}
							rule_id={bind.id}
							item_id={String(bind.file_template_id)}
							itemDict={itemDict}
							getRules={getBinds}
							setErrorApi={setErrorApi}
							deleteEndpoint={getAllTemplateBindsUrl}
						/>
					))}
			</div>
		</div>
	);
}


